import * as React from 'react'
import {makeStyles} from '@mui/styles'
import RXRIcon from './RXRIcon'
import {Spacing, Colors} from '../assets/styles'
import RXRButton from './RXRButton'
import PropTypes from 'prop-types'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: Colors.rxrWhiteColor,
    padding: Spacing.spaceSmall,
    borderRadius: 4,
    border: '1px solid ' + Colors.rxrPrimaryColor,
    gap: Spacing.spaceMedium,

    '& p': {
      width: '100%',
      whiteSpace: 'pre-line',

      '& strong': {
        fontWeight: 'bold',
      },
    },
  },
  messageIcon: {},
})

function MessageBox({iconSize, children, retry, buttonType, color, icon, className}) {
  const classes = useStyles()
  const messageColor = color || Colors.rxrRedColor
  const messageIcon = icon || RXRIcon.ERROR

  return (
    <div className={[classes.container, className].join(' ')} style={{borderColor: messageColor}}>
      <RXRIcon icon={messageIcon} size={iconSize || RXRIcon.SIZE_LARGE} color={messageColor} />
      <p style={{color: messageColor}}>{children}</p>
      {retry && (
        <RXRButton onClick={retry} type={buttonType || RXRButton.TYPE_DESTRUCTIVE}>
          Retry
        </RXRButton>
      )}
    </div>
  )
}

MessageBox.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  iconSize: PropTypes.number,
  retry: PropTypes.func,
  buttonType: PropTypes.string,
}

export default MessageBox
